import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router";
import { ProfileProfessionViewContainer } from "../components/profile-profession-view.container";
import { ProfileProfessionEditContainer } from "../components/profile-profession-edit.container";
import { getItem } from "../../../shared/local-storage";

export const ProfileProfession: React.FC = () => {
  const applicantUserId = getItem("applicantUserId");
  return (
    <div>
      <Helmet>
        <title>Profile - Profession</title>
      </Helmet>
      <Routes>
        <Route index element={<Navigate to="view" replace />} />
        <Route path="view/*" element={<ProfileProfessionViewContainer data={{ applicantId: applicantUserId }} />} />
        <Route path="edit/*" element={<ProfileProfessionEditContainer data={{ applicantId: applicantUserId }} />} />
      </Routes>
    </div>
  );
};
